module.exports = __webpack_public_path__ + "assets/img/1_1682.981c671a.jpg";